import React from 'react';

import Button from 'components/Button';
import IconFemtasy from 'components/IconFemtasy';

const GoBackHomeButton = () => {
  return (
    <Button
      icon={{
        alignment: 'left',
        component: <IconFemtasy icon="Homesolid" />,
      }}
      linkTo="/"
      title={{ id: 'components.Account.backToHome' }}
    />
  );
};

export default GoBackHomeButton;
